import { useContext, useState } from 'react'
import {
  Root,
  ButtonText,
  EmailBrochureIcon,
} from './EmailBrochureButtonStyles'
import { StoreContext } from '../../store'
import * as reducers from '../../store/reducers'
import { useEmailBrochure } from '../../utils/hooks/interiorBrochure'
import ProgressModal from '../ProgressModal/ProgressModal'
import { useRouteMatch } from 'react-router'
import useInteriorById from '../../hooks/interiorById'

/**
 * Extracts the interior id from the url. If no interior id is found,
 * returns null.
 * @returns {number | null}
 */
function useInteriorId() {
  const match = useRouteMatch('/client/:clientName/interior/:id')
  return match ? parseInt(match.params.id, 10) : null
}

function useClientName() {
  const match = useRouteMatch('/client/:clientName')
  return match?.params.clientName
}

export default function EmailBrochureButton(props) {
  const clientName = useClientName()
  const interiorId = useInteriorId()

  const trigger = useEmailBrochure()
  const { dispatch, isSignedIn, prospect } = useContext(StoreContext)
  const [isEmailing, setIsEmailing] = useState(false)

  const { interior } = useInteriorById(clientName, interiorId)

  const sendEmailBrochure = async (prospect) => {
    try {
      setIsEmailing(true)
      await trigger(prospect)

      dispatch(
        reducers.setSnackBar({
          open: true,
          duration: 5000,
          message: 'Successfully sent brochure!',
          type: 'success',
          position: { horizontal: 'right', vertical: 'top' },
        })
      )
    } catch (err) {
      dispatch(
        reducers.setSnackBar({
          open: true,
          duration: 5000,
          message: 'Failed to send brochure. Please try again later!',
          type: 'error',
          position: { horizontal: 'right', vertical: 'top' },
        })
      )
    } finally {
      setIsEmailing(false)
    }
  }

  const handleEmailBrochure = () => {
    if (!isSignedIn) {
      dispatch(
        reducers.setBuyerLoginDialog({
          open: true,
          message: 'Please sign-in to use this feature',
        }),
        // reducers.setLoginNotificationDialogOpen(true),
        reducers.setBuyerAuthCallback((prospect) => {
          sendEmailBrochure({
            prospect,
            interiorId,
            interiorName: interior?.name,
          })
        })
      )
      return
    } else {
      sendEmailBrochure({ prospect, interiorId, interiorName: interior?.name })
    }
  }

  return (
    <>
      <Root {...props} onClick={handleEmailBrochure}>
        <EmailBrochureIcon />
        <ButtonText variant="button">Email Brochure</ButtonText>
      </Root>
      <ProgressModal open={isEmailing} title={'Sending Brochure'} />
    </>
  )
}
